import { EntityDetailsWrapper, FlowOverview } from 'components';
import EntityJSONViewer from 'components/EntityDetails/EntityJSONViewer';
import { CACHE_FIRST, ENTITY_PATH_ID } from 'contracts/constants';
import type { EntityTab } from 'contracts/interfaces';
import { useLocation } from 'react-router-dom';
import { useGetFlowQuery, useGetPackageVersionQuery } from 'services/graphql/generated/hooks';
import { getParams } from 'utils';

const Flow = () => {
  const { pathname } = useLocation();
  const params: any = getParams(pathname, [ENTITY_PATH_ID]);

  const { data: packageVersion } = useGetPackageVersionQuery({
    ...CACHE_FIRST,
    variables: {
      uuid: params.versionUuid
    },
    skip: !params.versionUuid
  });

  const { data: flowData } = useGetFlowQuery({
    ...CACHE_FIRST,
    variables: {
      packageVersionUuid: params.versionUuid,
      uuid: params.entityId
    },
    skip: !(params.versionUuid && params.entityId)
  });

  const tabs: EntityTab[] = [
    { label: 'Overview', isActive: true, content: <FlowOverview params={params} /> },
    // { label: 'Settings', content: <FlowSettings /> },
    {
      label: 'JSON',
      content: (
        <EntityJSONViewer
          key={`${params.versionUuid},${params.entityId}_JSON`}
          name={flowData?.getFlow.name || ''}
          description={flowData?.getFlow.description || ''}
          data={flowData?.getFlow.schema}
        />
      )
    }
  ];

  return <EntityDetailsWrapper tabs={tabs} />;
};

export default Flow;
